"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const intl_1 = require("@kyruus/intl");
const round_1 = __importDefault(require("lodash/round"));
const react_2 = require("@xstate/react");
const expandable_card_container_1 = __importDefault(require("../ExpandableCardContainer/expandable-card-container"));
const ReviewsSectionHeader_1 = __importDefault(require("./ReviewsSectionHeader"));
const styles_1 = require("./styles");
const average_rating_1 = __importDefault(require("./average-rating"));
const sub_ratings_1 = __importDefault(require("./sub-ratings"));
const individual_reviews_1 = __importDefault(require("./individual-reviews"));
const individual_reviews_styles_1 = require("./individual-reviews.styles");
const search_reviews_machine_1 = __importStar(require("../../lib/machines/search-reviews-machine"));
const search_input_1 = __importDefault(require("./search-input"));
const messages_1 = __importDefault(require("../../lib/messages"));
const with_error_boundary_1 = require("../ErrorFallback/with-error-boundary");
const constants_1 = require("../../lib/constants");
const ProviderReviews = ({ provider, track }) => {
    var _a, _b;
    const aggregateRatings = (_a = provider.reviews) === null || _a === void 0 ? void 0 : _a.aggregate_ratings;
    const reviewsData = (_b = provider.reviews) === null || _b === void 0 ? void 0 : _b.reviews;
    const reviewCount = aggregateRatings === null || aggregateRatings === void 0 ? void 0 : aggregateRatings.review_count;
    const ratingCount = aggregateRatings === null || aggregateRatings === void 0 ? void 0 : aggregateRatings.rating_count;
    const [searchMachineState, sendToSearchMachine] = (0, react_2.useMachine)((0, search_reviews_machine_1.default)({ reviews: reviewsData }));
    const noResults = searchMachineState.matches(search_reviews_machine_1.STATES.noResults);
    // searching overrides the expanded state of the reviews UI
    // if there is no valid search, render the expanded or unexpanded reviews
    const { displayReviews } = searchMachineState.context;
    // Get the providers rating rounded to 1 precision point if available.
    const averageRating = (aggregateRatings === null || aggregateRatings === void 0 ? void 0 : aggregateRatings.average_rating) &&
        (0, round_1.default)(aggregateRatings.average_rating, 1);
    const subRatings = aggregateRatings === null || aggregateRatings === void 0 ? void 0 : aggregateRatings.sub_ratings;
    const showSubRatings = subRatings && subRatings.length > 0;
    return (react_1.default.createElement(expandable_card_container_1.default, { id: "profile-reviews-section", track: track },
        react_1.default.createElement("div", { itemProp: "aggregateRating", itemScope: true, itemType: "https://schema.org/AggregateRating" },
            react_1.default.createElement(ReviewsSectionHeader_1.default, null),
            averageRating && (react_1.default.createElement(styles_1.RatingsSection, null,
                react_1.default.createElement(average_rating_1.default, { averageRating: averageRating, ratingCount: ratingCount, reviewCount: reviewCount }),
                react_1.default.createElement(styles_1.ReviewsDisclaimer, null,
                    react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.ratingsDisclaimer))),
                showSubRatings && react_1.default.createElement(sub_ratings_1.default, { subRatings: subRatings }))),
            reviewsData && reviewsData.length >= constants_1.SEARCH_INPUT_REVIEW_COUNT ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(styles_1.ReviewsSearchInputTitle, null,
                    react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.reviewsSearchInputTitle))),
                react_1.default.createElement(search_input_1.default, { value: searchMachineState.context.searchTerm, showClearIcon: true, onChange: (e) => sendToSearchMachine({
                        type: search_reviews_machine_1.EVENTS.searchTermUpdated,
                        data: e.currentTarget.value
                    }), onClearIconClick: () => sendToSearchMachine({
                        type: search_reviews_machine_1.EVENTS.searchTermUpdated,
                        data: ''
                    }) }))) : null),
        reviewsData && reviewsData.length > 0 ? (react_1.default.createElement(individual_reviews_1.default, { reviews: displayReviews, searchTerm: searchMachineState.context.searchTerm, noResults: noResults, onClearButtonClick: () => sendToSearchMachine({
                type: search_reviews_machine_1.EVENTS.searchTermUpdated,
                data: ''
            }) })) : (react_1.default.createElement(individual_reviews_styles_1.NoReviewsContainer, null,
            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.noReviews))))));
};
exports.default = (0, with_error_boundary_1.withErrorBoundary)(ProviderReviews);
//# sourceMappingURL=provider-reviews.js.map